import { all, fork, takeEvery, select, call, put } from 'redux-saga/effects';
import actions from './actions';
import API_ENDPOINT from '../../settings';
import { makeSelectPageToken } from '../socialPage/selector';
import request from '../../helpers/request';

/* eslint func-names: ["error", "never"] */
/* eslint-disable no-return-await */

export function* loadCustomProfiles() {
  yield takeEvery(actions.LOAD_CUSTOM_PROFILE, function*(action) {
    const pageToken = yield select(makeSelectPageToken());

    const limit = action.limit ? action.limit : 50;
    const skip = action.skip ? action.skip : 0;
    const { fromDate, toDate, tags, profileType } = action;
    // console.log('pageToken', pageToken);
    let url = `${API_ENDPOINT.apiUrl}/custom-users?limit=${limit}&skip=${skip}`;
    url += `&fromDate=${fromDate}&toDate=${toDate}`;
    if (tags) url += `&tags=${tags}`;
    if (profileType) url += `&profileType=${profileType}`;

    try {
      const result = yield call(
        request,
        url,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${pageToken}`,
          },
        }
      );
      // console.log('loaded custom profiles', url, result);
      if (result && result.status === 'success') {
        yield put(actions.loadCustomProfilesSuccess(result.data, result.meta));
      } else if (result){
        throw new Error(result.message);
      } else {
        throw new Error('Unkown error: result is empty');
      }
    } catch (error) {
      // console.log('load custom profiles error', error.message);
      yield put({
        type: actions.LOAD_CUSTOM_PROFILE_ERROR,
        error: error.message,
      });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(loadCustomProfiles),
  ]);
}
